module.exports = __webpack_public_path__ + "static/media/cz.c1810364.svg";